import React from 'react';
import { Tag, Input, Tooltip } from 'antd';
import styled from 'styled-components';
import _ from 'lodash';

interface InputValue {
  currentValue: string;
  valueLists: string[];
}

interface ListItemInputProps {
  placeholder?: string;
  onChange?: (value: InputValue) => void;
  value?: InputValue;
  isValid?: boolean;
  className?: string;
}

function ListItemInput({
  onChange = () => {},
  value: { currentValue, valueLists } = { currentValue: '', valueLists: [] },
  isValid = true,
  placeholder,
  className,
}: ListItemInputProps) {
  const handleClose = (removedItem: string) => {
    const newValueLists = valueLists.filter((valueItem) => valueItem !== removedItem);
    onChange({
      valueLists: newValueLists,
      currentValue,
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      valueLists,
      currentValue: e.target.value,
    });
  };

  const handleInputConfirm = () => {
    if (isValid && currentValue.trim()) {
      const trimmed = currentValue.trim();
      const newValueLists =
        trimmed && !valueLists.includes(trimmed) ? [...valueLists, trimmed] : valueLists;
      onChange({
        valueLists: newValueLists,
        currentValue: '',
      });
    }
  };

  const onEditValueItem = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, valueItem: string) => {
    e.preventDefault();
    const newValueLists = valueLists.filter((item) => item !== valueItem);
    onChange({
      valueLists: newValueLists,
      currentValue: valueItem,
    });
  };

  return (
    <Root className={className}>
      {valueLists.length > 0 && (
        <TagsWrap>
          {valueLists.map((valueItem) => {
            const isLongTag = valueItem.length > 24;
            const tagElem = (
              <Tag
                key={valueItem}
                color="#1a2744"
                closable
                onClose={() => handleClose(valueItem)}
                style={{ borderRadius: 5, marginBottom: 6 }}
              >
                <span onDoubleClick={(e) => onEditValueItem(e, valueItem)}>
                  {_.truncate(valueItem, { length: 24 })}
                </span>
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={valueItem} key={valueItem}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
        </TagsWrap>
      )}
      <InputRow>
        <Input
          className="auth-text-input"
          type="text"
          value={currentValue}
          placeholder={placeholder}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={(e) => {
            e.preventDefault();
            handleInputConfirm();
          }}
        />
        <AddButton type="button" onClick={handleInputConfirm}>
          Add
        </AddButton>
      </InputRow>
    </Root>
  );
}

export default ListItemInput;

const Root = styled.div`
  width: 100%;
`;

const TagsWrap = styled.div`
  margin-bottom: 8px;
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .auth-text-input {
    flex: 1;
    min-width: 0;
  }
`;

const AddButton = styled.button`
  flex-shrink: 0;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #1a2744;
  background: #1a2744;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #243556;
    border-color: #243556;
  }
`;
